module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "aubrey.91bd0c4e.jpg";